import tracker from '../../components/tracker/publish'
import Analytics from '../analytics/Analytics'

var isIE11 = !!navigator.userAgent.match(/Trident\/7\.0/)

export default (props) => {
  return <a {...props} onClick={(e) => {
    tracker.trackEvent('userevent', props.track)
    Analytics.send(props.gaEvents.eventCategory, props.gaEvents.eventAction, props.gaEvents.eventLabel)
    if (typeof props.onClick === 'function') {
      props.onClick(e)
    } else if (props.href && isIE11) {
      window.location = props.href
    }
  }}>{props.children}</a>
}
